// WI#23 (coverage-map D1) — mirror of artifacts/api-server/src/lib/programWeek.ts; keep in step.
// A squad's schedule is "Week N + weekday". Week 1 is the Monday of the week the squad was
// created (UTC). Dates are YYYY-MM-DD calendar days.
export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const;
export type Weekday = (typeof WEEKDAYS)[number];

function shift(date: string, days: number): string {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function programAnchorMonday(squadCreatedAt: string): string {
  const c = new Date(squadCreatedAt);
  const d = new Date(Date.UTC(c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()));
  d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7));
  return d.toISOString().slice(0, 10);
}

/** Program week and weekday for a calendar date; week < 1 means before the program started. */
export function programDayFor(anchorMonday: string, date: string): { week: number; day: Weekday } {
  const days = Math.round((Date.parse(`${date}T00:00:00Z`) - Date.parse(`${anchorMonday}T00:00:00Z`)) / 86_400_000);
  return { week: Math.floor(days / 7) + 1, day: WEEKDAYS[((days % 7) + 7) % 7]! };
}

export function dateForProgramDay(anchorMonday: string, week: number, day: string): string {
  const idx = WEEKDAYS.findIndex((d) => d.toLowerCase() === day.toLowerCase());
  return shift(anchorMonday, (week - 1) * 7 + Math.max(idx, 0));
}
